<template>
  <div class="mybox">
    <home-header :isShow="true" activeIndex="2"></home-header>
    <div class="mycenter">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple left">
            <!-- <el-avatar :size="80" :src="user.head_portrait">
              <img src="@/assets/images/headerImg.jpg"/>
            </el-avatar> -->
            <el-image class="avatar" :src="user.head_portrait" fit="cover">
              <img class="avatar_img" slot="error" src="@/assets/images/headerImg.jpg" alt="" />
            </el-image>
            <div class="username">{{ user.nickname }}</div>
            <!-- <div @click="navToEditUserInfo" class="edit-btn">编辑资料</div> -->
            <router-link class="edit-btn" to="/edituserinfo">
              编辑资料</router-link
            >
          </div>
          <div class="btns_list">
            <left-list :activeIndex="activeIndex"></left-list>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content my_right">
            <comment-title titleText="我的作品" :isShow="false"></comment-title>
            <works-list></works-list>
          </div>
        </el-col>
      </el-row>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
// import HomeHeader from '@/components/Header'
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/Footer";
import CommentTitle from "@/components/Title";
import WorksList from "../components/WorksList";
import LeftList from "../components/LeftList";
export default {
  name: "My",
  components: {
    HomeHeader,
    HomeFooter,
    CommentTitle,
    WorksList,
    LeftList,
  },
  data() {
    return {
      user: {
        head_portrait: "",
        username: "",
      },
      activeIndex: "1",
    };
  },
  created() {
    let userinfo = JSON.parse(localStorage.getItem("user"));
    if (userinfo) {
      this.user = userinfo;
    } else {
    }

    console.log(this.user);
  },
  methods: {
    getWorks() {
      this.$api
        .myWorks()
        .then((res) => {
          //数据处理
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          this.$router.replace({
            path: "/login",
          });
        })
        .catch((err) => console.log(err));
    },
    navToEditUserInfo() {
      this.$router.push({ path: "/edituserinfo" });
    },
  },
};
</script>
<style lang="less" scoped>
.mybox {
  background-color: #f3f3f3;
  .mycenter {
    width: 1200px;
    margin: 20px auto;
    .left {
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: white;
      margin-bottom: 20px;
      border-radius: 10px;
      & /deep/ .el-avatar {
        margin-top: 40px;
      }
      .avatar {
        margin-top: 40px;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background-color: #58b75b;
        overflow: hidden;
        .avatar_img{
                  width: 80px;
        height: 80px;
        border-radius: 50%;
          object-fit: cover;
        }
      }
      .username {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        margin: 40px auto;
      }
    }
    .my_right {
      background: white;
      padding: 40px 0px 0px 0px;
      border-radius: 10px;
    }
  }
  .edit-btn {
    width: 100px;
    height: 40px;
    border: 1px solid #999999;
    border-radius: 20px;
    line-height: 40px;
    text-align: center;
    color: #999999;
    margin-bottom: 60px;
    cursor: pointer;
  }
}

</style>



// WEBPACK FOOTER //
// src/my/Pages/My.vue